export const initialState = {
  filters: {},
  staticPages: [],
  staticPage: {},
  loading: false,
  faqPage: []
};
